import { memo } from 'react';

import { CheckoutContributionConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutContributionConfirmationFormValues } from 'src/pages/Checkout/ContributionConfirmation/index';
import { StateFormReturnType } from 'src/utils/stateForm';
import { UiCleanCheckbox } from 'src/components/UI/checkbox/CleanCheckbox';
import { UiCard } from 'src/components/UI/Card';

type Props = {
  model: CheckoutContributionConfirmationResponseType['NotificationPreferencesSubsection'];
  formProps: StateFormReturnType<CheckoutContributionConfirmationFormValues>;
};

export const CheckoutConfirmationNotificationPreferences = memo<Props>(({ model, formProps }) => {
  const tHelper = useTHelper('checkout.confirmation.notificationPreferences');

  return (
    <>
      <h2 className="section-header">{tHelper('title')}</h2>
      <UiCard>
        <p className="text-center">{tHelper('select')}</p>
        <UiCleanCheckbox
          formProps={formProps}
          name="ReceiveEmailCampaignUpdates"
          disabled={!model.CanSubscribeToCampaignUpdates}
          label={tHelper('label', { singular: model.ProjectTerminology.Singular?.toLowerCase() || '' })}
        />
      </UiCard>
    </>
  );
});
